<template>
  <div class="load-profile-thumbnail-wrapper">
    <img :src="getThumbnail" class="load-profile-thumbnail-image" />
    <div
      v-if="!itemThumbnail && isLoading"
      class="load-profile-thumbnail-loading-text"
    >
      Vorschau wird geladen
    </div>
  </div>
</template>

<script>
import { createLoadProfileThumbnail } from '@/services/axios/data.api';
export default {
  data() {
    return {
      isLoading: false,
      thumbnail: null,
    };
  },
  props: {
    itemId: {
      type: String,
      required: true,
    },
    itemThumbnail: {
      type: String,
      default: null,
    },
  },
  mounted() {
    if (!this.itemThumbnail) {
      this.createLoadThumbnail();
    }
  },
  methods: {
    async createLoadThumbnail() {
      try {
        this.isLoading = true;
        const response = await createLoadProfileThumbnail(this.itemId);
        this.$emit('updateThumbnail', this.itemId, response.data.thumbnailUrl);
      } catch (error) {
        // console.log('Error', error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    getThumbnail() {
      return this.itemThumbnail
        ? this.itemThumbnail
        : require('@/assets/img/dummy-load-data.svg');
    },
  },
};
</script>

<style scoped>
.load-profile-thumbnail-wrapper img {
  width: 100%;
}
.load-profile-thumbnail-wrapper {
  position: relative;
}
.load-profile-thumbnail-loading-text {
  position: absolute;
  top: 50%;
  left: 50%;
  font-size: 16px;
  transform: translate(-50%, -50%);
}
</style>
